import { ComponentProps } from 'react';

import { formatUsername } from '@pletly/shared';
import { UserNameField } from '../UserNameField';
import { FormInput, FormInputProps } from '../../Input';

type Props = ComponentProps<typeof UserNameField> &
	Omit<FormInputProps, 'name'> & {
		name?: string;
	};

export const UsernameFormInput = ({ name = 'username', ...props }: Props) => (
	<FormInput
		testID="username"
		InputComponent={UserNameField}
		name={name}
		transform={formatUsername}
		{...props}
	/>
);
